<section id="about">
  <div class="grid-container">
    <div>
      <h3 class="title">درباره ما</h3>

      <p class="text-justify" style="line-height: 30px; text-align: justify">
        <strong>شاپد</strong> (سامانه شناسایی، احراز هویت و پایش دریایی) با هدف
        ایجاد بستری <strong>امن</strong>، <strong>شفاف</strong> و
        <strong>یکپارچه</strong> برای شناسایی و مدیریت شناورهای دریایی کشور
        توسعه یافته است. این سامانه با فراهم‌سازی
        <strong>هویت معتبر</strong> برای شناورها، زمینه ارائه
        <strong>خدمات هوشمند</strong>، <strong>مدیریت هدفمند سوخت</strong>،
        بهبود فرآیندهای <strong>نظارتی</strong> و افزایش
        <strong>شفافیت</strong> در خدمات دریایی را فراهم می‌کند. شاپد می‌کوشد با
        بهره‌گیری از <strong>فناوری‌های نوین</strong>، گامی مؤثر در
        <strong>سامان‌دهی شناورهای صیادی و غیرصیادی</strong>،
        <strong>ارتقای بهره‌وری</strong>، <strong>کاهش تخلفات</strong> و
        <strong>توسعه مدیریت هوشمند دریایی کشور</strong> بردارد.
      </p>
    </div>
    <div>
      <h3 class="title">راه های ارتباطی</h3>

      <div>
        <ul style="line-height: 33px">
          <li>
            <strong>شرکت رایان اندیشه نصر:</strong> تهران، نارمک، بزرگراه شهید
            سلیمانی، بعد از چهارراه سرسبز، پلاک ۶۴۰، واحد ۸، تلفن ۲-۷۷۲۷۳۱۶۰-۰۲۱
          </li>
          <li>
            <strong>دفتر بندرعباس: </strong>{{ "09177563345" | faNum }} -
            {{ "33381408-076" | faNum }}
          </li>
          <li>
            <strong>دفتر ساری: </strong>{{ "09118644288" | faNum }} -
            {{ "33391200-011" | faNum }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<footer id="site-footer">
  <div class="inner-content">
    <div class="flex-container">
      <a href="https://rayanandisheh.com/" class="" target="_blank">
        طراحی و توسعه شرکت دانش بنیان رایان اندیشه نصر - {{ version | faNum }}
      </a>
    </div>
  </div>
</footer>
